<template>
  <div class="modal active" v-scroll-lock="active">
    <div class="modal-overlay"></div>

    <form
      class="modal-container appointment-simple"
      @submit.prevent="saveFinancialStatement()"
    >
      <header class="modal-header appointment-simple__header">
        <a
          class="btn btn-clear float-right appointment-simple__close"
          aria-label="close"
          @click="close()"
        >
        </a>

        <h1 class="financial-statement__title">Lançamento financeiro</h1>
      </header>

      <article class="modal-body appointment-simple__body financial-statement">
        <!-- Tipo -->
        <div class="financial-statement__row financial-statement__row--gap">
          <div class="financial-statement__col financial-statement__col--icon">
            <dr-icon
              :key="'category-icon'"
              ref="category-icon"
              name="categoryAlt"
              fill="gray"
              class="financial-statement__icon"
            />
          </div>

          <div class="financial-statement__col">
            <ul class="financial-statement__type">
              <li
                v-for="(type, index) in formData.type.radios"
                :key="`financialStatement-type-${index}`"
                class="financial-statement__type-name"
              >
                <input
                  v-model="formData.type.value"
                  :value="type.value"
                  :id="`financial-statement__type--${String(type.name).toLowerCase()}`"
                  name="financial-statement__type"
                  class="financial-statement__type-radio"
                  type="radio"
                >

                <label
                  :for="`financial-statement__type--${String(type.name).toLowerCase()}`"
                  :class="[
                    'financial-statement__type-label',
                    `financial-statement__type-label--${String(type.name).toLowerCase()}`
                  ]"
                >
                  {{ type.label }}
                </label>
              </li>
            </ul>
          </div>
        </div>

        <!-- Campos iteráveis -->
        <div
          v-for="(field, index) in formData"
          :key="`financialStatementField-${index}`"
          :class="field.iterable && 'financial-statement__row--gap'"
          class="financial-statement__row"
        >
          <template v-if="field.iterable">
            <div class="financial-statement__col financial-statement__col--icon">
              <dr-icon
                :key="'calendar-icon'"
                :ref="`${field.icon}-icon`"
                :name="field.icon"
                fill="gray"
                class="financial-statement__icon"
              />
            </div>

            <div class="financial-statement__col">
              <dr-field
                :form.sync="formData"
                :field.sync="formData[field.name]"
                :value.sync="formData[field.name].value"
                :id="`financialStatement_${field.name}`"
                :ref="`financialStatement_${field.name}`"
                :key="`financialStatement_${field.name}`"
                :class="[
                  field.class,
                  (field.name !== 'value' && formData[field.name].value) && 'has-value',
                  (field.name === 'value' && formData[field.name].value.value) && 'has-value',
                  (field.name === 'date' && $v.formData[field.name].$invalid) && 'has-error'
                ]"
                prefix="financialStatement_"
              />
            </div>
          </template>
        </div>

        <!-- Status do pagamento -->
        <div class="financial-statement__row">
          <div class="financial-statement__col financial-statement__col--icon"></div>

          <div class="financial-statement__col">
            <dr-switch
              v-model="formData.paymentStatus.value"
              :id="formData['paymentStatus'].name"
              label-checked="Pagamento efetuado"
              label-unchecked="Aguardando pagamento"
            />
          </div>
        </div>
      </article>

      <footer class="financial-statement__footer">
        <dr-submit
          :disabled.sync="$v.$invalid"
          :sending="loading"
          class="appointment-simple__submit"
          text="Salvar"
        />
      </footer>
    </form>
  </div>
</template>

<script>
import { formData, validations } from '@/data/formData/financialStatement'
import DrField from '@/components/form/field'
import DrSubmit from '@/components/form/submit'
import DrSwitch from '@/components/form/switch'
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'financialStatement',

  components: {
    DrField,
    DrSubmit,
    DrSwitch
  },

  props: {
    active: {
      type: Boolean,
      required: false,
      default: () => true
    },

    financialCategories: {
      type: Array,
      required: true,
      default: () => []
    },

    financialStatement: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  validations: {
    formData: validations
  },

  data () {
    return {
      formData,
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    prefix () {
      return `/${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor_office/${this.office.id}`
    },

    isEdit () {
      return !!this.formData.id.value
    }
  },

  created () {
    this.formData.category.options = this.financialCategories
    if (this.financialStatement) {
      this.loadFinancialStatement()
    } else {
      this.formData.type.value = 'RECEITA'
      this.formData.date.value = this.$moment().format('DD/MM/YYYY')
    }
  },

  mounted () {
    this.$nextTick(() => {})
    this.$v.formData.$reset()
  },

  destroyed () {
    this.destroyApiObject(this.formData)
  },

  methods: {
    loadFinancialStatement () {
      this.formData.id.value = this.financialStatement.id
      this.formData.type.value = this.financialStatement.type
      this.formData.date.value = this.$moment(this.financialStatement.date).format('DD/MM/YYYY')
      this.formData.description.value = this.financialStatement.description
      this.formData.category.value = this.financialStatement.financial_category.id
      this.formData.value.value.raw = Math.abs(this.financialStatement.value)
      this.formData.value.value.converted = this.$root.$options.filters.TO_BRL(this.financialStatement.value)
      this.formData.paymentStatus.value = !!this.financialStatement.is_consolidated

      const selectedMethod = this.formData.paymentMethod.options.filter(el => {
        return el.value === this.financialStatement.payment_method
      })
      if (selectedMethod.length) {
        this.formData.paymentMethod.value = selectedMethod[0].id
      }
    },

    saveFinancialStatement () {
      const sufix = this.isEdit ? `/${this.formData.id.value}` : ''

      const url = `${this.prefix}/financial_statement${sufix}`
      const method = this.isEdit ? 'put' : 'post'
      const data = this.buildApiObject(this.formData)
      const headers = this.$store.getters.getAuthHeader.headers

      this.loading = true
      this.fn_SHOW_PROGRESS()
      this.$http({ url, method, data, headers })
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Lançamento financeiro salvo com sucesso.',
            size: 'md',
            active: true
          })

          EventBus.$emit('reload-finance')
          this.close()
        })
        .catch(err => this.handleError(err))
        .finally(() => {
          this.loading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    buildApiObject (data) {
      const date = this.$moment(data['date'].value, 'DD/MM/YYYY', true)
        .format('YYYY-MM-DD')

      const type = data['type'].value
      const value = data['value'].value.raw
      const description = data['description'].value
      const financialCategory = data['category'].value
      const paymentMethod = data['paymentMethod'].options
        .find(i => i.id === data['paymentMethod'].value).value
      const isConsolidated = data['paymentStatus'].value

      return {
        'financial_statement': {
          date,
          description,
          type,
          paymentMethod,
          financialCategory,
          value,
          isConsolidated
        }
      }
    },

    destroyApiObject (object) {
      const recursiveNullify = (obj) => {
        for (const key in obj) {
          if ('value' in obj[key]) {
            obj[key].value = null
          } else {
            recursiveNullify(obj[key])
          }
        }
      }

      recursiveNullify(object)

      object.paymentStatus.value = 0

      object.value = {
        iterable: true,
        icon: 'dollar',
        type: 'currency',
        name: 'value',
        placeholder: 'Valor',
        mask: '####',
        class: 'appointment-simple__input',
        value: {
          converted: null,
          raw: 0
        }
      }
    },

    close () {
      this.$emit('cancel', true)
    },

    findErrorMessage (object) {
      let errorMessage = null

      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }

      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }

      return errorMessage
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    }
  }
}
</script>
